import React from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { BoxImage } from './BoxImage';
export function Hero() {
  return <section className="pt-5 pb-5 px-4 sm:px-6 bg-white text-center" data-id="element-77" data-mp="ehtiju9l4xmr">
      <div className="inline-block px-3 py-1 rounded-full bg-gold/15 border border-gold/50 text-navy font-heading font-bold text-[10px] sm:text-xs uppercase tracking-widest mb-2.5" data-id="element-78" data-mp="9llb731mq8q5">
        Sistema Completo 6-in-1
      </div>

      <h1 className="text-[22px] leading-tight sm:text-4xl font-heading font-extrabold text-navy mb-2" data-id="element-79" data-mp="127eeddqu7pdg">
        Il Sistema Completo di Pianificazione per Running Coach
      </h1>

      <p className="text-[13px] sm:text-lg text-anthracite font-semibold leading-snug mb-3 max-w-2xl mx-auto" data-id="element-80" data-mp="s9q93tvluzh1">
        Risparmia ore ogni settimana preparando programmi di corsa, sessioni di
        allenamento e pianificazioni stagionali, senza dover creare tutto da zero
        ogni volta.
      </p>

      <BoxImage wrapperClassName="mb-3" className="max-w-[280px] sm:max-w-md drop-shadow-xl" data-id="element-81" data-mp="380w1849w55gb" />

      <div className="mb-2.5 max-w-lg mx-auto" data-id="element-82" data-mp="3j6g1bysfzti2">
        <CTAButton data-id="element-83" data-mp="3o7vgxbbup7t2">🚀 SÌ! VOGLIO RUNNING COACH PRO™ ORA</CTAButton>
      </div>

      <TrustRow data-id="element-84" data-mp="39al869qleg11" />
    </section>;
}